import React, { memo } from 'react';
import icons from '../assets/icons';
/**
 * In order to add the new icon into the sprite
 * please add icons to common/assets/icons/index.ts
 */
var Icon = function (_a) {
    var name = _a.name, className = _a.className, dataTestId = _a.dataTestId, role = _a.role;
    var _b = icons[name], id = _b.id, viewBox = _b.viewBox;
    return (React.createElement("svg", { viewBox: viewBox, className: className, "data-testid": dataTestId, role: role },
        React.createElement("use", { href: "#" + id })));
};
Icon.defaultProps = {
    dataTestId: 'icon',
};
export default memo(Icon);
